<template>
  <v-app id="app" light>
    <template>
      <v-main>
        <v-container class="new-account white py-5" fill-height fluid>
          <v-fade-transition>
            <v-row v-if="!loading" align="center" class="fill-height" no-gutters>
              <v-col class="text-center px-xl-16" cols="12" lg="4" md="6" offset-lg="4" offset-md="3" offset-xl="4"
                     xl="4">
                <div class="text-center pb-2">
                  <a :alt="$t('title')" href="https://ekd.fi/" target="_blank">
                    <img
                      :alt="$t('title')"
                      :style="{ width: $vuetify.breakpoint.smAndDown ? '50%' : '60%' }"
                      src="/img/EKD-logo.png"
                      style="height: auto"
                    />
                  </a>
                </div>

                <div
                  :class="$vuetify.breakpoint.xsOnly ? 'subtitle-2 font-weight-bold' : 'headline'"
                  class="primary--text text-center mb-12"
                >
                  {{ $t('tenants.new_tenant_title') }}
                </div>

                <v-card class="ma-0 pa-0" color="transparent" elevation="0" light style="width: 100%">
                  <p class="text-body-2 text-md-body-1 text-center grey--text text--darken-1 mt-5">
                    {{ $t('tenants.new_tenant_info') }}</p>

                  <div :class="$vuetify.breakpoint.xsOnly ? 'caption' : ''"
                       class="text-body-2 text-md-body-1 text-center grey--text text--darken-1 mt-5">
                    {{ $t('required_fields_are_marked_with_asterisk') }} (<span class="red--text">*</span>).
                  </div>

                  <v-row>
                    <v-col cols="12">
                      <v-form ref="form">
                        <v-text-field
                          v-model="name"
                          :label="$t('tenants.organization_name')"
                          :rules="[$rules.required]"
                          autocomplete="organization"
                          autofocus
                          class="mt-2 mb-4 organization_name required"
                          color="primary"
                          outlined
                          type="text"
                          validate-on-blur
                        ></v-text-field>

                        <template v-if="false">
                          <v-text-field
                            v-model="registrationNumber"
                            :label="$t('tenants.registration_number')"
                            :rules="[$rules.required]"
                            autocomplete="registrationNumber"
                            class="mt-2 organization_registration_number required"
                            color="primary"
                            outlined
                            type="text"
                            validate-on-blur
                          ></v-text-field>
                          <v-text-field
                            v-model="streetAddress"
                            :label="$t('tenants.details.street_address')"
                            :rules="[$rules.required]"
                            autocomplete="streetAddress"
                            class="mt-2 organization_street_address_line_1 required"
                            color="primary"
                            outlined
                            type="text"
                            validate-on-blur
                          ></v-text-field>
                          <v-text-field
                            v-model="streetAddressLine2"
                            :label="$t('tenants.details.street_address_2')"
                            autocomplete="streetAddressLine2"
                            class="mt-2 organization_street_address_line_2"
                            color="primary"
                            outlined
                            type="text"
                            validate-on-blur
                          ></v-text-field>
                          <v-text-field
                            v-model="zipCode"
                            :label="$t('tenants.details.zip_code')"
                            :rules="[$rules.required]"
                            autocomplete="zipCode"
                            class="mt-2 organization_zip_code required"
                            color="primary"
                            outlined
                            type="text"
                            validate-on-blur
                          ></v-text-field>
                          <v-text-field
                            v-model="city"
                            :label="$t('tenants.details.city')"
                            :rules="[$rules.required]"
                            autocomplete="city"
                            class="mt-2 organization_city required"
                            color="primary"
                            outlined
                            type="text"
                            validate-on-blur
                          ></v-text-field>
                        </template>

                        <country-select v-model="country" :dark="false" :rules="[$rules.required]"
                                        required
                        ></country-select>

                        <template v-if="false">
                          <v-text-field
                            v-model="addressCounty"
                            :label="$t('tenants.details.state_province_region')"
                            autocomplete="county"
                            class="mt-2 organization_county"
                            color="primary"
                            outlined
                            type="text"
                            validate-on-blur
                          ></v-text-field>
                        </template>
                      </v-form>
                      <v-alert :value="showAlert" class="mt-4" text type="error">
                        {{ $t('validation.check_all_required_fields') }}
                      </v-alert>
                      <v-btn :loading="saving" block class="mt-5" color="primary" large
                             @click="saveOrganization">
                        <span>{{ $t('tenants.new_tenant_save') }}</span>
                      </v-btn>
                      <v-btn
                        block
                        class="mt-3 font-weight-bold" color="primary" large text
                        @click="logout">
                        {{ $t('login.logout') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-fade-transition>
        </v-container>
      </v-main>
    </template>
  </v-app>
</template>

<script>
import CountrySelect from '../components/CountrySelect';
import userApi from '../api/user';

export default {
  name: 'NewAccountView',
  components: {
    CountrySelect,
  },
  data() {
    return {
      saving: false,
      subtleLoading: false,
      name: '',
      registrationNumber: '',
      streetAddress: '',
      streetAddressLine2: '',
      addressCounty: '',
      city: '',
      zipCode: '',
      country: null,
      showAlert: false,
      loading: false,
    };
  },
  methods: {
    async saveOrganization() {
      if (!this.$refs.form.validate()) {
        this.showAlert = true;
        return;
      }

      this.saving = true;

      const data = {
        name: this.name,
        registrationNumber: this.registrationNumber,
        streetAddress: this.streetAddress,
        streetAddressLine2: this.streetAddressLine2,
        city: this.city,
        zipCode: this.zipCode,
        country: this.country,
        addressCounty: this.addressCounty,
      };

      try {
        const tenant = await userApi.createTenant(data);
        this.$router.replace({name: 'tenant_onboarding', params: {tenantId: tenant.id}});
        this.$nextTick(() => {
          window.location.reload();
        });
      } catch (error) {
        this.$handleApiError(error);
      }

      this.saving = false;
    },
    logout() {
      // this logout for remote (if not used e.g. local logout used then service has 'rememberme'-functionality)
      this.$Amplify.Auth.signOut().then(() => {
        // this is client side only logout
        this.$clearUserInfo();
        this.$store.commit('setLoadingOverlay', true);
        this.$store.commit('setLoggedIn', false);
        this.$router.push({name: 'login'});
      });
    },
  },
  computed: {},
};
</script>

<style scoped></style>
